
var kvAnim = {
	bgScale:0,
	ease:'easeInOutCubic',
	copy_step:0,
	init:function(){
		var t=this;
		t.bgScale = 1.5;

		$('.wrap_left').stop().velocity('stop').velocity({translateX:'500px',translateY:'-800px'},1);
		$('.wrap_right').stop().velocity('stop').velocity({translateX:'-500px',translateY:'800px'},1);
		$('.bg_cover').stop().velocity('stop').velocity({opacity:1},1);
		$('.main_sholder').stop().velocity('stop').velocity({opacity:0},1);
		$('.main_ttl').stop().velocity('stop').velocity({opacity:0},1);
		$('.sub_ttl').stop().velocity('stop').velocity({opacity:0},1);
		$('.watch_the_video').stop().velocity('stop').velocity({opacity:0},1);

		$('.kv_scrl_block').each(function(i,elm){
			kvAnim.copyInit($(elm));
		});
		$('.fv_area').stop().velocity('stop').velocity({top:'75%',translateY:'-100%',translateX:'-50%'},{duration:0});
		

		//Indicator
		$('.product_kv').append('<ul id="kv_indi"></ul>');

		$('.kv_scrl_block').each(function(i,elm){
			let dom = '';
			dom += '<li><a href="#kv-block0'+i+'" class="indi_'+i+'" data-num="'+i+'"></a></li>';
			$('#kv_indi').append(dom);

			// $('.indi_'+i).click(function(){
			// 	let num = $(this).attr('data-num');
			// 	$.scrollify.move('#block'+num);
			// 	return false;
			// });
		});


	},
	show:function(){
		var t = this;
		$('.wrap_left').stop().velocity('stop').velocity({translateX:'0px',translateY:'0px'},{duration:1400,delay:500,easing:'easeOutCubic'});
		$('.wrap_right').stop().velocity('stop').velocity({translateX:'0px',translateY:'0px'},{duration:1400,delay:500,easing:'easeOutCubic'});
		$('.bg_covor').stop().velocity('stop').velocity({opacity:0},{duration:1400,delay:500,easing:'easeOutCubic'});
		$('.main_sholder').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:2000});
		$('.main_ttl').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:2500});
		$('.sub_ttl').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:2500});
		$('.watch_the_video').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:3000});
	},
	step0:function(){
		var t = this;
		let spd = 750;
		let dly = 250;
		t.copy_step=0;
		$('.wrap_left').stop().velocity('stop').velocity({translateX:'0px',translateY:'0px',blur:'0'},{duration:spd,delay:dly,easing:'easeOutCubic'});
		$('.wrap_right').stop().velocity('stop').velocity({translateX:'0px',translateY:'-20px',blur:'0'},{duration:spd,delay:dly,easing:'easeOutCubic'});
		
		$('.bg_color').stop().velocity('stop').velocity({opacity:0},{duration:spd,delay:dly,easing:t.ease});
		$('.fv_area').stop().velocity('stop').velocity({top:'75%',translateY:'-100%',translateX:'-50%'},{duration:spd,delay:dly,easing:t.ease});
		$('.main_sholder').stop().velocity('stop').velocity({translateY:0,opacity:1},{duration:spd,delay:dly});
		$('.main_ttl').stop().velocity('stop').velocity({scale:1,opacity:1},{duration:spd,delay:dly});
		$('.sub_ttl').stop().velocity('stop').velocity({opacity:1},{duration:spd,delay:dly});
		$('.watch_the_video').stop().velocity('stop').velocity({translateY:0,opacity:1},{duration:spd,delay:dly});
	},
	step1:function(){
		var t = this;
		let spd = 1000;
		t.copy_step=1;
		let target_y = (cmn_mode == "sp")? '38%':'45%';
		$('.wrap_left').stop().velocity('stop').velocity({translateX:'-90px',translateY:'150px',blur:'5px'},{duration:spd,easing:'easeOutCubic'});
		$('.wrap_right').stop().velocity('stop').velocity({translateX:'90px',translateY:'-150px',blur:'5px'},{duration:spd,easing:'easeOutCubic'});
		$('.bg_color').stop().velocity('stop').velocity({opacity:0},{duration:spd,easing:t.ease});
		$('.fv_area').stop().velocity('stop').velocity({top:target_y,translateY:'-100%',translateX:'-50%'},{duration:spd,delay:0,easing:t.ease});
		$('.main_sholder').stop().velocity('stop').velocity({translateY:'-150%',opacity:0},{duration:spd,delay:0,easing:'linear'});
		$('.main_ttl').stop().velocity('stop').velocity({scale:.62,opacity:1},{duration:spd,delay:0,easing:t.ease});
		$('.sub_ttl').stop().velocity('stop').velocity({opacity:0},{duration:spd,delay:0,easing:t.ease});
		$('.watch_the_video').stop().velocity('stop').velocity({translateY:'150%',opacity:0},{duration:spd,delay:0,easing:'linear'});
	},
	step99:function(step_flg){
		var t = this;
		let spd = 500;

		let opt = step_flg? 1 :0;

		$('.fv_area').velocity({opacity:opt,translateY:'-100%',translateX:'-50%'},spd);
	},
	copyInit:function($block){
		let $tag = $block.find('.kv_copy_area');

		$tag.find('.ttl').velocity('stop').velocity({scale:1.8,opacity:0,translateY:'0px'},{duration:0,delay:0});
		$tag.find('.desc').velocity('stop').velocity({translateY:'100px',opacity:0},{duration:0,delay:0});
		$tag.hide();
	},
	copyStep:function($block,num){
		var t = this;
		let spd = 750;
		let dly = (t.copy_step > 0)? 500 : 1000;
		t.copy_step = num + 2;

		let $tag = $block.find('.kv_copy_area');

		t.copyInit($block);
		$block.addClass('go');
		$tag.show();
		$tag.find('.ttl').stop(false,true).velocity('stop').velocity({scale:1,opacity:1},{duration:spd,delay:dly,easing:t.ease});
		$tag.find('.desc').stop(false,true).velocity('stop').velocity({translateY:0,opacity:1},{duration:spd,delay:dly,easing:t.ease});

		$('#kv_indi li a.indi_'+num).addClass('active');
	},
	leave:function(){
		var t = this;
		let spd = 500;
		let $block = $('.kv_scrl_block.go');
		let $tag = $block.find('.kv_copy_area');
		$tag.find('.ttl').velocity('stop').velocity({opacity:0,translateY:'-100px',scale:1},{duration:spd,delay:0,easing:t.ease});
		$tag.find('.desc').velocity('stop').velocity({opacity:0,translateY:'-100px'},{duration:spd,delay:100,easing:t.ease,complete:function(){
			t.copyInit($block);
		}});

		$block.removeClass('go');

		$('#kv_indi li a.active').removeClass('active');
	}
}
